
import { MoodRating } from "./MoodRating";
import { LucideIcon } from "lucide-react";

interface MoodRatingSectionProps {
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export function MoodRatingSection({ value, onChange, disabled = false }: MoodRatingSectionProps) {
  const handleSelect = (newValue: string) => {
    if (disabled) return;
    onChange(newValue);
  };

  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium mb-1">How are you feeling today?</label>
      <div className="flex justify-between gap-2">
        <MoodRating 
          value="1" 
          label="Struggling" 
          selected={value === "1"}
          onSelect={handleSelect}
          disabled={disabled}
        />
        <MoodRating 
          value="2" 
          label="Down" 
          selected={value === "2"}
          onSelect={handleSelect}
          disabled={disabled}
        />
        <MoodRating 
          value="3" 
          label="Neutral" 
          selected={value === "3"}
          onSelect={handleSelect}
          disabled={disabled}
        />
        <MoodRating 
          value="4" 
          label="Good" 
          selected={value === "4"}
          onSelect={handleSelect}
          disabled={disabled}
        />
        <MoodRating 
          value="5" 
          label="Excellent" 
          selected={value === "5"}
          onSelect={handleSelect}
          disabled={disabled}
        />
      </div>
    </div>
  );
}
